import axios from "axios"
import axiosRetry from "axios-retry"
import { shoudlShowApiLogs } from "../config/constants"
import jwt_decode from "jwt-decode"

// axios auto retry
axiosRetry(axios, { retries: 6, retryDelay: (retryCount) => 2000 * retryCount })

// .env variables
const baseUrl = import.meta.env.VITE_API_URL

// refresh access token
const refreshToken = async () => {
  const decodedAccessToken = jwt_decode(
    localStorage.getItem("accessToken")!
  ) as any
  const username = decodedAccessToken.username

  const config = {
    method: "post",
    url: baseUrl + "/refresh",
    data: {
      refreshToken: localStorage.getItem("refreshToken"),
      username: username,
    },
  }

  const { data } = await axios(config)

  return data.customAuth.AuthenticationResult
}

// check if token is valid and if it's not, refresh it
export const checkToken = async () => {
  const token = localStorage.getItem("accessToken")!

  try {
    const decodedToken: any = jwt_decode(token)

    if (Date.now() >= decodedToken.exp * 1000) {
      console.log("refreshing token")
      const result = await refreshToken()

      if (result && result.AccessToken) {
        localStorage.setItem("accessToken", result.AccessToken)
        return result.AccessToken
      } else {
        return token
      }
    }

    return token
  } catch (e) {
    console.log("token refresh error", e)

    // logout user
    localStorage.clear()
    window.location.reload()

    return false
  }
}

// get method
export const get = async (path: string, headers?: object) => {
  if (shoudlShowApiLogs) {
    console.log(`GET ${baseUrl}` + path)
  }

  let token = await checkToken()

  const config = {
    method: "get",
    url: baseUrl + path,
    headers: {
      Authorization: "Bearer " + token,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
    },
  }

  if (headers) {
    config.headers = {
      ...config.headers,
      ...headers,
    }
  }

  return axios(config)
}

// post method
export const post = async (
  path: string,
  body?: object,
  headers?: object,
  withAuth = true
) => {
  if (shoudlShowApiLogs) {
    if (body) {
      console.log(`POST ${baseUrl}` + path, body)
    } else {
      console.log(`POST ${baseUrl}` + path)
    }
  }

  let token = ""
  if (withAuth) {
    token = await checkToken()
  }

  const config = {
    method: "post",
    url: baseUrl + path,
    headers: {
      Authorization: "Bearer " + token,
    },
    data: body,
  }

  if (headers) {
    config.headers = {
      ...config.headers,
      ...headers,
    }
  }

  return axios(config)
}

// put method
export const put = async (path: string, body?: object, headers?: object) => {
  if (shoudlShowApiLogs) {
    if (body) {
      console.log(`PUT ${baseUrl}` + path, body)
    } else {
      console.log(`PUT ${baseUrl}` + path)
    }
  }

  let token = await checkToken()

  const config = {
    method: "put",
    url: baseUrl + path,
    headers: {
      Authorization: "Bearer " + token,
    },
    data: body,
  }

  if (headers) {
    config.headers = {
      ...config.headers,
      ...headers,
    }
  }

  return axios(config)
}

// delete method
export const deleteMethod = async (path: string, headers?: object) => {
  if (shoudlShowApiLogs) {
    console.log(`DELETE ${baseUrl}` + path)
  }

  let token = await checkToken()

  const config = {
    method: "delete",
    url: baseUrl + path,
    headers: {
      Authorization: "Bearer " + token,
    },
  }

  if (headers) {
    config.headers = {
      ...config.headers,
      ...headers,
    }
  }

  return axios(config)
}
